import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import ProtectedRoute, {
  ProtectedRoutePropsFromDispatch,
  ProtectedRoutePropsFromState
} from '../components/ProtectedRoute';
import { RootState, selectLoggedInStatus } from '../store';
import { initSessionCheck } from '../store/app/actions';

const mapStateToProps = (state: RootState): ProtectedRoutePropsFromState => ({
    isLoggedIn: selectLoggedInStatus(state)
});

const mapDispatchToProps = (
  dispatch: Dispatch
): ProtectedRoutePropsFromDispatch => ({
  getLoginStatus: () => dispatch(initSessionCheck())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProtectedRoute);
